import classNames from 'classnames'
import { useQuery } from '@apollo/client'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper'
import { Container } from 'modules/marketplace/layout/components/ResponsiveContainers'
import ProductItem from 'modules/marketplace/common/components/ProductItem'

import 'swiper/css'
import 'swiper/css/free-mode'
import styles from './RelatedProductList.module.css'

import GET_RELATED_PRODUCTS_FOR_PUBLISHED_PRODUCT from './graphql/GetRelatedProductsForPublishedProduct.graphql'
import {
  GetRelatedProductsForPublishedProduct,
  GetRelatedProductsForPublishedProductVariables
} from './graphql/__generated__/GetRelatedProductsForPublishedProduct'

type ProductQueryVariables = {
  sellerSlug: string
  catalogSlug: string
  productSlug: string
  isPreview: boolean
}

type ProductListProps = {
  classname?: string
  queryVariables: ProductQueryVariables
}

const RelatedProductList = ({ classname, queryVariables }: ProductListProps) => {
  const { data } = useQuery<GetRelatedProductsForPublishedProduct, GetRelatedProductsForPublishedProductVariables>(
    GET_RELATED_PRODUCTS_FOR_PUBLISHED_PRODUCT,
    {
      variables: queryVariables
    }
  )

  const seller = data?.marketplaceSeller
  const catalog = data?.marketplaceSeller?.marketplaceCatalog
  const products = data?.marketplaceSeller?.marketplaceCatalog?.publishedProducts?.nodes
    .filter(product => product.slug !== queryVariables.productSlug)
    .slice(0, 5)

  const isPreview = queryVariables.isPreview

  if (seller && catalog && products && products.length > 0) {
    return (
      <div className={classNames(styles.container, classname)}>
        <Container>
          <h3 className={styles.sectionTitle}>More products from {seller?.displayName}</h3>
          <div className={styles.productList}>
            <Swiper
              freeMode
              modules={[FreeMode]}
              slidesPerView="auto"
              className={styles.swiper}
              spaceBetween={16}
              breakpoints={{
                768: {
                  spaceBetween: 48
                }
              }}>
              {products.map(product => (
                <SwiperSlide key={product.id} className={styles.productItem}>
                  <ProductItem
                    hasCatalogName={false}
                    hasSellerName={false}
                    showPrices={false}
                    showAddToCart={false}
                    product={product}
                    catalog={catalog}
                    seller={seller}
                    isPreview={isPreview}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Container>
      </div>
    )
  }

  return null
}

export default RelatedProductList
